//                       (https://www.healthunlocked.com/:community-slug/posts/private/:post-id)(/post-title)
export const POST_URL = /(https?:\/\/(?:www.)?healthunlocked.com\/[\w-]+\/posts\/(?:private\/)?\d+)(\/[\w-]+)?/i;

// detect the expressions of the form @[n] with an integer
export const MENTIONED_USERS_ID = /@\[([0-9]+)]/g;

// detect emoticons
// [8:;] - starts with any of these chars
// ['-]{0,} - optionally has an extra char, like hyphen eg, :-D
// (&#39;){0,1} - for smiley's with single quote, since single quote is encoded. eg, :'(
// [dDpPoOxX|/\)\(] - followed by one of these charset: d,D,p,P,o,O,x,X,|,),(
export const SMILEYS = /[8:;]['-]{0,}('){0,1}[dDpPoOxX|\/\)\(](?=$|\s)/g;

// Found on http://daringfireball.net/2010/07/improved_regex_for_matching_urls
export const URL_RE = /((?:(?:f|ht)tps?:\/\/(?:www\.)?|www\.)(.*?)(?=(?:[\)\]\.,;!?])*(?:\s|$)))/g;

export const YOUTUBE_URL = /(?:youtube\.com\/watch\?v=|youtu\.be\/)(.*)/;

// special format tags for posts and replies. eg. [b]bold[/b] [i]italic[/i] [u]underline[/]
export const BBCODE = /\[\/?(?:b|i|u)]/g;

export const UNDESIRABLE_CHARACTERS = [{ pattern: /\xa0/gi, replacement: ' ' }];

export const EMAIL = /[\w\.%+-]+@[\w\.-]+\.[A-Z]+/i;

export const PHONE_NUMBER = /\(?([0-9]{2,})\)?[-. ]?([0-9]{3,})[-. ]?([0-9]{3,})/;
